<template>
    <div :class="show && 'home_matches_show2'" class="home_matches" v-if="info && info.votes > 0">
        <div v-if="info" class="home_matches_body">
            <span class="home-titles">Man of the match</span>
            <div class="versus2">
                <p class="teams"> {{ info.home_team }} </p>
                <p>vs</p>
                <p class="teams">{{ info.away_team }} </p>
            </div>
            <div class="plin">
                <div class="player-img">
                    <img :src="info.player_pic" alt="Player Photo">
                </div>
                <div class="player-details">
                    <span>{{ info.player_name }}</span>
                    <div class="pa21">
                        <span> {{ info.age }} years old</span>
                    </div>
                    <div class="player-nationality">
                        <img :src="info.player_nationality_logo" alt="Flag">
                        <span>{{ info.player_nationality }}</span>
                    </div>
                    <div class="player-info">
                        <span class="position">{{ info.player_position }}</span>
                        <span class="numb"> #{{ info.player_number }}</span>
                    </div>

                    <div>
                        {{ ordinalMaker(info.seasons) }} season at the club
                    </div>
                    <div class="votes">
                        <span>{{ info.votes }} {{ info.votes > 1 ? 'Votes' : 'Vote' }}</span>
                    </div>

                </div>
            </div>
            <router-link :to="{ name: 'motm' }" class="nnd">
                <span class="more_p">Go to Votes</span> </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MatchesHome',
    inject: ['backendServer', 'currentHost'],
    props: ['show'],
    data() {
        return {
            info: null,
        }
    },
    mounted() {

        fetch(this.backendServer() + '/latest-mop-player', {
            method: "GET",
            credentials: "include"
        })
            .then((response) => response.json())
            .then((data) => {
                this.info = data;
            });

    },
    methods: {
        ordinalMaker(num) {
            if (num === 0) return (num + 1) + 'st';
            else if (num === 1) return num + 'st';
            else if (num === 2) return num + 'nd';
            else if (num === 3) return num + 'rd';
            else return num + 'th';
        },
    }

}
</script>

<style scoped>
.home_matches {
    position: relative;
    overflow: hidden;
}

p.teams img {
    border-radius: 50%;
}

p {
    margin-bottom: 0 !important;
}

div.versus2 {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: monospace;
}

p.teams {
    font-size: .8em;
    flex-basis: 35%;
    display: grid;
    justify-items: center;
}

.plin {
    display: flex;
    /* margin: 15px 0; */
    padding: 2px 8px;
    border-radius: 8px;
}

.player-img {
    margin-right: 15px;
}

.player-img img {
    width: 150px;
    height: 150px;
    -o-object-fit: cover;
    object-fit: cover;
    border-radius: 15%;
    border: 2px solid #291717;
}

.player-details {
    text-align: left;
    font-family: monospace;
    font-size: .7em;
    margin-top: 13px;
}

div.votes {
    font-size: 1.2em;
    font-weight: bold;
    color: #d32f2f;
}


/* .player-info {

} */

/* .position {
    font-size: 0.85em;
    color: #555;
    background-color: #eee;
    padding: 2px 6px;
    border-radius: 4px;
} */

/* .number {
    font-size: 0.85em;
    font-weight: bold;
    color: #d32f2f;
} */

.player-nationality {
    display: flex;
    align-items: center;

}

.player-nationality img {
    width: 20px;
    margin-right: 5px;
}


/* .more_p {
    margin-top: 10px;
    padding: 6px 12px;
    background-color: #d32f2f;
    color: white;
    border-radius: 4px;
    text-decoration: none;
    font-size: 0.9em;
} */
</style>